import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollCreateEmployeeInput,
  PayrollCreateEmployeeGraphQLRequest,
  CreateEmployeeResponse,
} from '../types';

const payrollCreateEmployeeMutation = gql`
  mutation PayrollCreateEmployee($input: PayrollCreateEmployeeInput!) {
    payrollCreateEmployee(input: $input) {
      code
      success
      message
      data {
        peopleId
        inviteSent
      }
    }
  }
`;

export const createEmployee = (input: PayrollCreateEmployeeInput) => {
  return graphQLApi<CreateEmployeeResponse, PayrollCreateEmployeeGraphQLRequest>({
    query: payrollCreateEmployeeMutation,
    queryVariables: { input },
  });
};
